import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";
import FormMini from "../components/forms/FormMini";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Lead Generation - Elm Street</title>
        <meta
          name="description"
          content="Powerful intention-based, pay-per-click lead generation done for you. Whether you want 5, 50 or 500 leads a month...Elm Street's lead generation can grow and scale to meet the needs of your business, and your budget."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/lead_generation" />
        <meta property="og:title" content="Lead Generation - Elm Street" />
        <meta
          property="og:description"
          content="Powerful intention-based, pay-per-click lead generation done for you. Whether you want 5, 50 or 500 leads a month...Elm Street's lead generation can grow and scale to meet the needs of your business, and your budget."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />




      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>leaving <span style={{color:"#f69c26"}}>already?</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>Take a complimentary strategy guide with proven strategies for generating listing leads.
                </div>
                
                <FormMini buttonText="give me the guide" successMsg={<div style={{textAlign:"center"}}><Button variant="contained" color="secondary" href="/assets/listings.pdf">Download the PDF</Button></div>}
              formName="es2_listingsguide" listId="148013" utmOverride="exit_intent"/>
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/listgo.jpg"
                    width="590px"
                    height="242px"
                    alt="Listings, Listings, Listings! FREE Guide"
                   
                  />
                  </div>
     </ExitModal>







      <div
        style={{
          backgroundImage: "url('leadgenbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
        alt="Elm Street Lead Generation"
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>exclusive </span>
                    <br />
                    real estate leads
                  </Typography>
                  <p>
                    Lead Generation Done For You.
                    <br />
                    Limited Availability. Act Fast.
                    <br />
                    <br />
                    <Button variant="contained" color="secondary" href="#form">
                      claim your markets today
                    </Button>
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "65px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12}>
                <div>
                  <Image
                    src="/lead1.png"
                    width="1000px"
                    height="1000px"
                    alt="Elm Street Lead Generation - Done for you PPC Lead Generation"
                  />
                </div>
              </Grid>
              <Grid item md={7} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  done for you
                  <br />
                  <span style={{ color: "#f69c26" }}>PPC lead generation</span>
                </Typography>
                <br />
                <span>
                  Powerful intention-based, pay-per-click lead generation done for you. Whether you want 5, 50 or 500
                  leads a month...Elm Street's lead generation can grow and scale to meet the needs of your business,
                  and your budget.
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg3.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  <span style={{ color: "#f69c26" }}>
                    smart
                    <br />
                  </span>{" "}
                  path leads
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  Elm Street's Smart Path Leads will append important contact data to your leads, and then automatically
                  nurture them via email and text, ensuring you stay top of mind.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image src="/lead2.png" width="1000px" height="931px" alt="Elm Street Lead Generation - Smart XXXX" />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={6} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  follow-up
                  <br />
                  <span style={{ color: "#f69c26" }}> concierge</span>
                </Typography>
                <br />
                <span>
                  Elm Street's AI Concierge will automatically connect with each of your leads immediately, learning
                  more about them and keeping them engaged until they are ready to connect.
                  <br />
                  <br />
                  All you need to do is follow-through
                  <br />
                  and work your sales magic!
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      claim your markets
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={6} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/convo.gif"
                    width="450px"
                    height="645px"
                    unoptimized={true}
                    alt="Elm Street Lead Generation - Follow-Up Concierge"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('esbg2.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "35px",
            paddingBottom: "85px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12}>
                <div>
                  <Image
                    src="/lead4.png"
                    width="595px"
                    height="565px"
                    alt="Elm Street Lead Generation - Nurture Campaigns"
                  />
                </div>
              </Grid>
              <Grid item md={7} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4" style={{ color: "#ffffff" }}>
                  nurture
                  <br />
                  <span style={{ color: "#f69c26" }}>campaigns</span>
                </Typography>
                <br />
                <span style={{ color: "#ffffff" }}>
                  Enjoy intelligent email &amp; text communication workflows for buyers and sellers designed to engage,
                  educate, and entertain during every part of the sales journey. All automated and personalized.
                  <br />
                  <br />
                  <strong>
                    Daily Market Reports for Buyers
                    <br />
                    Introduction &amp; Outreach Emails
                    <br />
                    Monthly Lifestyle Newsletters
                  </strong>
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      schedule demo
                    </Button>
                  </div>
                </span>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div>
        <Container
          maxWidth="lg"
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "25px",
          }}
        >
          <div style={{ marginTop: "55px" }}>
            <Grid container spacing={8}>
              <Grid item md={5} sm={12} style={{ paddingBottom: "20px" }}>
                <Typography variant="h4" component="h4">
                  <span style={{ color: "#f69c26" }}>
                    intuitive
                    <br />
                    lead management
                    <br />
                  </span>{" "}
                  dashboard
                </Typography>
                <br />
                <span>
                  Never miss another opportunity with Elm Street's intuitive Elevate dashboard. You'll have visibility
                  into all of your leads, see where they are in the communication workflow, and be prompted for
                  follow-up and outreach when leads are ready to engage.
                  <div style={{ paddingTop: "20px" }}>
                    <Button variant="contained" color="secondary" href="#form">
                      check availability
                    </Button>
                  </div>
                </span>
              </Grid>
              <Grid item md={7} sm={12} style={{ marginBottom: "-6px" }}>
                <div>
                  <Image
                    src="/lead5.png"
                    width="1000px"
                    height="762px"
                    alt="Elm Street Lead Generation - Intuitive Lead Management Dashboard"
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>

      <div
        style={{
          backgroundImage: "url('orangebg.webp')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg" style={{ paddingTop: "80px", paddingBottom: "85px" }}>
          <div style={{}}>
            <a id="form" />
            <Typography variant="h4" component="h4" style={{ color: "#1d1746", textAlign: "center" }}>
              claim your markets today
            </Typography>
            <div style={{ paddingBottom: "40px", textAlign: "center" }}>
              <strong style={{ color: "#1d1746", textAlign: "center" }}>
                Connect with an Elm Street Success Coach to Check Availability.
              </strong>
            </div>
            <div style={{ padding: "40px", backgroundColor: "#ffffff" }}>
              <Container
                maxWidth="lg"
                style={{
                  paddingLeft: "20px",
                  paddingRight: "20px",
                  marginTop: "65px",
                  marginBottom: "65px",
                }}
              >
                <Grid container>
                  <Grid item md={2} sm={12} xs={12} />
                  <Grid item md={8} sm={12} xs={12}>
                    <DemoForm
                      buttonText="Schedule Demo"
                      successUrl="thankyou"
                      listId="147986"
                      formName="es2_lead_generation"
                      fieldList={["first_name", "last_name", "email", "phone", "roll", "markets"]}
                    />
                  </Grid>
                </Grid>
              </Container>
            </div>
          </div>
        </Container>
      </div>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
